import React from 'react';
import InnerFilterContent, { FilterInnerContentProps } from '../../common/DropdownContent/DynamicFilterInnerContent';
import { OrderType, OrderUtil } from '../../../../../types/order/';

export default function OrderTypeFilterInnerContent({
  filter,
  filterProps,
  setFilterProps,
}: FilterInnerContentProps<string>) {
  return (
    <InnerFilterContent
      filter={filter}
      filterProps={{ filterProps, setFilterProps }}
      items={[...(filterProps.orderType || [])]}
      text={item => OrderUtil.typeToString(item as OrderType)}
      onRemove={i => {
        filterProps.orderType?.delete(i);
        if (!filterProps.orderType?.size) filterProps.orderType = undefined;
        setFilterProps({ ...filterProps });
      }}
    />
  );
}
